if (!customElements.get('multicolumn-carousel')) {
  customElements.define(
    'multicolumn-carousel',
    class MulticolumnCarousel extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        this.selectors = {
          swiper: '.swiper',
          wrapper: '.swiper-wrapper',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination'
        };

        this.swiperEl = this.querySelector(this.selectors.swiper);
        if (!this.swiperEl) return;

        this.wrapper = this.swiperEl.querySelector(this.selectors.wrapper);

        this.desktopColumns = parseFloat(this.swiperEl.dataset.pcColumns) || 1;
        this.mobileColumns = parseFloat(this.swiperEl.dataset.mobileColumns) || 1;

        this.enableDesktop = this.swiperEl.dataset.desktopCarousel === 'true';
        this.enableMobile = this.swiperEl.dataset.mobileCarousel === 'true';

        this.totalSlides = this.wrapper?.children.length || 0;
        // ✅ If only one slide, add full-width class
        if (this.totalSlides === 1) {
          this.classList.add('full-width');
        }
        this.mqlDesktop = window.matchMedia('(min-width: 768px)');
        this.mqlDesktop.addEventListener('change', this.init.bind(this));

        this.init();


      }

      init() {
        const isDesktop = this.mqlDesktop.matches;
        const enabled = isDesktop ? this.enableDesktop : this.enableMobile;
        // const visibleSlides = isDesktop ? this.desktopColumns : this.mobileColumns;
        if (!enabled) {
          this.destroySlider();
          return;
        }
        this.initSlider();
      }

      initSlider() {
        if (this.sliderInstance) return;

        const nextEl = this.querySelector(this.selectors.nextEl);
        const prevEl = this.querySelector(this.selectors.prevEl);
        const pagination = this.querySelector(this.selectors.pagination);

        const gap = window
          .getComputedStyle(this.wrapper)
          .getPropertyValue('gap');

        const spaceBetween = parseFloat(gap) || 16;

        const options = {
          slidesPerView: this.mobileColumns,
          spaceBetween,
          threshold: 2,
          watchOverflow: true,

          breakpoints: {
            768: {
              slidesPerView: this.desktopColumns
            }
          },

          navigation:
            nextEl && prevEl
              ? { nextEl, prevEl }
              : false,

          pagination:
            pagination
              ? { el: pagination, clickable: true }
              : false
        };

        this.sliderInstance = new window.FoxTheme.Carousel(
          this.swiperEl,
          options
        );

        this.sliderInstance.init();
        this.expendSlideItem();
      }
      expendSlideItem() {
        const expandButtons = this.querySelectorAll('.expand-slide');
        if (!expandButtons.length) return;

        expandButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const slide = button.closest('.swiper-slide');
            const wrapper = this.wrapper;
            const slides = [...wrapper.children];
            const index = slides.indexOf(slide);

            const isExpanded = slide.classList.contains('expanded-width');

            // Reset
            slides.forEach(s => s.classList.remove('expanded-width'));
            this.querySelectorAll('.expand-slide.active')
              .forEach(b => b.classList.remove('active'));

            if (isExpanded) {
              wrapper.style.transform = '';
              return;
            }

            slide.classList.add('expanded-width');
            button.classList.add('active');

            // === SAME LOGIC AS YOUR jQuery CODE ===
            const slideWidth = slides[this.sliderInstance.slider.activeIndex]
              .getBoundingClientRect().width;

            const translateX = -(slideWidth * index);

            wrapper.style.transform = `translate3d(${translateX}px, 0, 0)`;

            // keep swiper state in sync
            this.sliderInstance.slider.slideTo(index, 0, false);
          });
        });
      }


      destroySlider() {
        if (!this.sliderInstance) return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      disconnectedCallback() {
        this.destroySlider();
      }
    }
  );
}
